import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';
import { Button, Card, Icon, Image, Label } from 'semantic-ui-react';
import i18next from 'i18next';
import SubcategoriesLinks from './SubcategoriesLinks';
import { formatPrice } from '../../../helpers/format';
import { confirm, deleteOverrides } from '../../../actions';

import './MenuItem.scss';

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    paddingTop: 8,

    // change background colour if dragging
    // background: "lightgray",

    // styles we need to apply on draggables
    ...draggableStyle
});

const styles = {
    itemPosId: {
        minWidth: 'max-content',
        flex: 1,
        textAlign: 'center',
        borderColor: 'rgba(0,0,0,.08)',
        borderRightStyle: 'solid',
        borderLeftStyle: 'solid',
        borderWidth: 1.2,
        marginLeft: 10,
        marginRight: 10
    },
    override: {
        fontWeight: 'bold',
        fontStyle: 'italic'
    }
};

class MenuItem extends Component {
    state = { safeDelete: false }

    handleItemDelete = () => {
        if (this.state.safeDelete) {
            const { item } = this.props;
            this.props.handleRemove(item);
            this.setState({ safeDelete: false });
        } else {
            this.setState({ safeDelete: true });
            setTimeout(() => this.setState({ safeDelete: false }), 2000);
        }
    }

    handleOverrideClick = (item) => {
        const { confirm, deleteOverrides, branchIdForOverride } = this.props;

        confirm({
            title: i18next.t('menu.syncOverrideTitle'),
            message: `${i18next.t('menu.syncOverrideMessage')}: ${Object.keys(item.branchOverrides).join(', ')}`,
            onConfirm: () => {
                deleteOverrides(item.menuId, branchIdForOverride, 'itemInstance', item.id);
                deleteOverrides(item.menuId, branchIdForOverride, 'item', item.itemId);
            }
        });
    }

    render() {
        const { item, index } = this.props;

        let { originalPrice: price, originalPosItemId: posItemId } = item;
        let priceOverride = false;
        let posItemIdOverride = false;

        if (typeof item.price === 'number') {
            priceOverride = true;
            price = item.price;
        }
        if (item.posItemId) {
            posItemIdOverride = true;
            posItemId = item.posItemId;
        }

        return (
            <Draggable draggableId={`item-${item.id}`} index={index}>
                {(provided, snapshot) => (
                    <div
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                        style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                        className="menu-item-card"
                    >
                        <Card color={!item.isAvailable ? 'red' : null}>
                            <Card.Content>
                                <Button floated="right" circular size='mini' icon='trash' basic negative={this.state.safeDelete} onClick={this.handleItemDelete} />
                                <Button floated="right" circular size='mini' icon='write' basic onClick={() => this.props.handleUpdate(item)} />
                                <Image className={item.imageUrl ? 'zoom' : ''} floated='left' size='mini' src={item.imageUrl || 'https://react.semantic-ui.com/images/wireframe/image.png'} />
                                <Card.Header>{`${item.name} ${item.meta && item.meta.pizzaCover || ''}`}</Card.Header>
                                <Card.Meta>
                                    {item.description ? <Label circular className="tooltip">i<span className="tooltiptext">{item.description}</span></Label> : null}
                                    <span>
                                        {item.options.supportedFor.includes('sitting') ? <Icon name='food' /> : null}
                                        {item.options.supportedFor.includes('takeaway') ? <Icon name='shopping bag' /> : null}
                                        {item.options.supportedFor.includes('delivery') ? <Icon name='motorcycle' /> : null}
                                    </span>
                                    {item.branchOverrides ? <div className="tooltip" style={{ borderBottom: 'none' }}><Icon name='warning sign' color="yellow" onClick={() => this.handleOverrideClick(item)} /><span className="tooltiptext">{Object.keys(item.branchOverrides).join(' | ')}</span></div> : null}
                                </Card.Meta>
                            </Card.Content>
                            <Card.Content extra style={{ padding: 10, paddingTop: 5, paddingBottom: 5 }}>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ minWidth: 'max-content' }}>{item.key}</div>
                                    <div style={{ ...styles.itemPosId, ...posItemIdOverride ? styles.override : {} }}>{posItemId}</div>
                                    <div style={{ minWidth: 'max-content', ...priceOverride ? styles.override : {} }}>{formatPrice(price, this.props.currencyCode)}</div>
                                </div>
                            </Card.Content>
                            {!item.subcategories || !item.subcategories.length ? null :
                                <Card.Content extra>
                                    <SubcategoriesLinks subcategories={item.subcategories} onSubcategoryClick={this.props.handleSubcategoryClick} />
                                </Card.Content>
                            }
                        </Card>
                    </div>
                )}
            </Draggable>
        );
    }
}

MenuItem.propTypes = {
    handleSubcategoryClick: PropTypes.func,
    handleRemove: PropTypes.func,
    item: PropTypes.object,
    handleUpdate: PropTypes.func,
    currencyCode: PropTypes.string,
    
    confirm: PropTypes.func,
    deleteOverrides: PropTypes.func,
    branchIdForOverride: PropTypes.string,
    index: PropTypes.number,
};

export default connect(null, { confirm, deleteOverrides })(MenuItem);
